import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-down-left', 'ArrowDownLeft', [["path",{"d":"M17 7l-10 10","key":"svg-0"}],["path",{"d":"M16 17l-9 0l0 -9","key":"svg-1"}]]);